import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <img
                src="/logo-1.png"
                alt="Janacode"
                className="footer-logo-img"
              />
            </div>
            <p className="footer-tagline">India's Code, Everyone's Product.</p>
          </div>
          <div className="footer-links">
            <div className="footer-links-col">
              <p className="footer-col-title">Company</p>
              <a href="#about">About</a>
              <a href="#philosophy">Philosophy</a>
              <a href="#sectors">Sectors</a>
            </div>
            <div className="footer-links-col">
              <p className="footer-col-title">Products</p>
              <a href="#products">SocietyHub</a>
              <a href="https://society-hub.in/marketing/presentation.html" target="_blank" rel="noopener noreferrer">Sales Deck</a>
            </div>
            <div className="footer-links-col">
              <p className="footer-col-title">Contact</p>
              <a href="mailto:info@janacode.com">info@janacode.com</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Janacode Technologies LLP. All rights reserved.
          </p>
          <p className="footer-made">Made with ❤️ in India</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
